import * as React from "react";

// import { MenuButton, ListItemDecorator, Menu, MenuItem, Dropdown } from '@mui/joy';
// import { ArrowDropUp, ArrowRight } from '@mui/icons-material';
import styled from "styled-components";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button
} from "@chakra-ui/react";

import { TriangleUpIcon, TriangleDownIcon } from "@chakra-ui/icons";

type DropdownMenuProps<T> = {
  items: T[];
  itemtype: string;
  onChange: (item: T) => void;
  onFormat: (item: T) => string;
  style?: React.CSSProperties;
  selected: T;
};

export default function SpeedDropdown<T>({
  items,
  onChange,
  onFormat,
  style,
  selected
}: DropdownMenuProps<T>) {
  return (
    <Menu isLazy>
      {({ isOpen }) => (
        <>
          <MenuButton
            as={Button}
            bg={"white"}
            color={"black"}
            fontWeight={400}
            rightIcon={
              isOpen ? (
                <TriangleDownIcon boxSize={2} />
              ) : (
                <TriangleUpIcon boxSize={2} />
              )
            }
          >
            {onFormat ? onFormat(selected) : String(selected)}
          </MenuButton>
          <MenuList
            className="speed-dropdown"
            sx={{
              width: "2rem"
            }}
            // sx={{
            //   // padding: '0 0.8rem',
            //   // height: '2.3rem',
            //   padding: '0',
            //   '--ListItemDecorator-item': '12px',
            //   zIndex: 300,
            // }}
          >
            {items.map((item: T) => (
              <MenuItem
                key={String(item)}
                role="menuitemradio"
                aria-checked={item === selected ? "true" : "false"}
                onClick={() => {
                  // setSelected(item);
                  onChange(item);
                }}

                // sx={{
                //   height: "2.3rem",
                //   padding: "0 4px",
                //   gap: "4px",
                //   display: "flex",
                //   flexDirection: "row",
                //   alignItems: "center"
                // }}
              >
                {/* <ListItemDecorator
              sx={{
                paddingBottom: '0.2rem',
              }}
            >
              {item === selected && <ArrowRight />}
            </ListItemDecorator> */}
                <ButtonText>
                  {onFormat ? onFormat(item) : String(item)}
                </ButtonText>
              </MenuItem>
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
}

const ButtonText = styled.span`
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
  letter-spacing: 0.03rem;
`;
